import screenfull from "../../node_modules/screenfull";
import BaseView from "../core/views/BaseView";
import C_GameEvent from "../core/const/C_GameEvent";

class SplashScreen extends BaseView
{

    constructor()
    {
        super();

        // messageHandler('createScroller');
        window.postMessage('createScroller', '*');

        this.hand = new PIXI.Sprite(this.assets.resources.hand.texture);
        this.layout.propHeightScale(this.hand, 25);
        this.layout.horizontalAlignCenter(this.hand);
        this.layout.verticalAlignTop(this.hand, 50);
        this.addChild(this.hand);
        TweenMax.to(this.hand, 2, {y:this.hand.y - this.layout.relHeight(20), repeat:-1});
        TweenMax.from(this.hand, .25, {alpha:0});

        // setOnSwipe(this.onSwipe.bind(this));
        // window.addEventListener('message', this.onSwipe.bind(this));
    }


    static onSwipe()
    {

        if (PIXI.app.model.isAndroid())
        {
            if (screenfull.enabled)
            {
                screenfull.request();
            }
        }
        PIXI.app.dispatcher.emit(C_GameEvent.SPLASH_CLOSED);


    }


    destroy()
    {
        TweenMax.killTweensOf(this.hand);
        super.destroy();
    }


}

export default SplashScreen